export default "<app-edit-profile\n  [adminAccess]=\"adminAccess\"\n  [user]=\"model\"\n  [vessels]=\"vessels\"\n></app-edit-profile>\n";